import { render, staticRenderFns } from "./TextToAudioModel.vue?vue&type=template&id=a049e4bc&"
import script from "./TextToAudioModel.vue?vue&type=script&lang=js&"
export * from "./TextToAudioModel.vue?vue&type=script&lang=js&"
import style0 from "./TextToAudioModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports